var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeanArterialPressure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H7.12022C7.52348 1.00402 7.90892 1.17436 8.19272 1.47398C8.47652 1.77361 8.63572 2.17828 8.6357 2.6V7.4C8.63572 7.82172 8.47652 8.22639 8.19272 8.52602C7.90892 8.82564 7.52348 8.99598 7.12022 9H1V1Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5176 7.54483C15.0548 7.54483 16.3009 6.24176 16.3009 4.63435C16.3009 3.02694 15.0548 1.72388 13.5176 1.72388C11.9805 1.72388 10.7344 3.02694 10.7344 4.63435C10.7344 6.24176 11.9805 7.54483 13.5176 7.54483Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83789 8.27618V8.99999C5.83789 9.38349 5.91036 9.7632 6.05114 10.1173C6.19192 10.4714 6.39823 10.793 6.65823 11.0634C6.91822 11.3339 7.22677 11.5479 7.56613 11.6933C7.90549 11.8387 8.26898 11.9125 8.6357 11.9105H10.7559C11.4909 11.9064 12.1943 11.5978 12.712 11.0522C13.2296 10.5066 13.5192 9.76856 13.5173 8.99999V4.63428",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2166 14.0896H12.1328C11.3643 14.0896 10.7412 14.7411 10.7412 15.5448C10.7412 16.3485 11.3643 17.0001 12.1328 17.0001H14.2166C14.9852 17.0001 15.6082 16.3485 15.6082 15.5448C15.6082 14.7411 14.9852 14.0896 14.2166 14.0896Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5447H15.6084",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3916 8.27612V9.76184C2.3916 11.3056 2.97807 12.7862 4.02199 13.8779C5.0659 14.9695 6.48176 15.5828 7.95808 15.5828H10.7413",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7832 1V6.82095",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeanArterialPressure);
export default __webpack_public_path__ + "static/media/MeanArterialPressure.96dc53826065b1f010499b271b5cac1d.svg";
export { ForwardRef as ReactComponent };